import * as React from 'react';
import { Fade } from '@lendi-ui/transition';
import styled from 'styled-components';
import { jsx } from 'react/jsx-runtime';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Wrapper = styled.div.withConfig({
  displayName: "indexstyle__Wrapper",
  componentId: "lui__sc-1p9iizv-0"
})(["position:fixed;z-index:", ";top:0;right:0;bottom:0;left:0;background-color:#000000;opacity:0.4;"], props => {
  var _props$zIndex;

  return (_props$zIndex = props.zIndex) !== null && _props$zIndex !== void 0 ? _props$zIndex : 2;
});

class Overlay extends React.Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "handleClick", () => {
      var {
        onClickHide = true,
        onHide
      } = this.props;

      if (onClickHide && onHide) {
        onHide();
      }
    });

    _defineProperty(this, "handleKeyPress", event => {
      if (event.key !== 'Escape') {
        return;
      }

      var {
        onClickEscape = true,
        onHide
      } = this.props;

      if (onClickEscape && onHide) {
        onHide();
      }
    });
  }

  activate() {
    window.addEventListener('keydown', this.handleKeyPress);
  }

  deactivate() {
    window.removeEventListener('keydown', this.handleKeyPress);
  }

  componentDidMount() {
    var {
      isVisible
    } = this.props;

    if (isVisible) {
      this.activate();
    }
  }

  componentDidUpdate(prevProps) {
    var {
      isVisible: prevShow
    } = prevProps;
    var {
      isVisible: currShow
    } = this.props;

    if (currShow !== prevShow) {
      if (currShow) {
        this.activate();
      } else {
        this.deactivate();
      }
    }
  }

  componentWillUnmount() {
    var {
      isVisible
    } = this.props;

    if (isVisible) {
      this.deactivate();
    }
  }

  render() {
    var {
      isVisible,
      children,
      zIndex
    } = this.props;
    return /*#__PURE__*/jsx("div", {
      children: /*#__PURE__*/jsx(Fade, {
        isActive: isVisible,
        isVisible: isVisible,
        shouldMountOnEnter: true,
        shouldUnmountOnExit: true,
        children: /*#__PURE__*/jsx(Wrapper, {
          onClick: this.handleClick,
          zIndex: zIndex,
          children: children
        })
      })
    });
  }

}

export { Overlay, Overlay as default };
